import React, { useContext } from 'react'
import { CalculatorContext } from '../context'

const Tabs = () => {
  const { tabs, setActiveTab } = useContext(CalculatorContext)

  return (
    <ul className='price__tabs'>
      {
        tabs.map((tab, index) => {
          return <li key={tab.name} onClick={() => setActiveTab(index)} className={`price__tab ${tab.isActive ? 'price__tab--active' : ''}`}>{tab.name}</li>
        })
      }
    </ul>
  )
}

export default Tabs
